// Fetch list

export const FETCH = 'reportCostCenterResults.FETCH'
export const FETCH_STARTED = 'reportCostCenterResults.FETCH_STARTED'
export const FETCH_FULFILLED = 'reportCostCenterResults.FETCH_FULFILLED'
export const FETCH_REJECTED = 'reportCostCenterResults.FETCH_REJECTED'
export const FETCH_CANCELLED = 'reportCostCenterResults.FETCH_CANCELLED'

// Clear

export const CLEAR = 'reportCostCenterResults.CLEAR'

// Export

export const EXPORT = 'reportCostCenterResults.EXPORT'
export const EXPORT_FULFILLED = 'reportCostCenterResults.EXPORT_FULFILLED'

// Fetch details

export const FETCH_DETAILS = 'reportCostCenterResults.FETCH_DETAILS'
export const FETCH_DETAILS_STARTED = 'reportCostCenterResults.FETCH_DETAILS_STARTED'
export const FETCH_DETAILS_FULFILLED = 'reportCostCenterResults.FETCH_DETAILS_FULFILLED'
export const FETCH_DETAILS_REJECTED = 'reportCostCenterResults.FETCH_DETAILS_REJECTED'
export const FETCH_DETAILS_CANCELLED = 'reportCostCenterResults.FETCH_DETAILS_CANCELLED'

// Clear details

export const CLEAR_DETAILS = 'reportCostCenterResults.CLEAR_DETAILS'

// Export details

export const EXPORT_DETAILS = 'reportCostCenterResults.EXPORT_DETAILS'
export const EXPORT_DETAILS_FULFILLED = 'reportCostCenterResults.EXPORT_DETAILS_FULFILLED'
